/**
 * Invoices API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  createCustomInvoice,
  createInvoice,
  fiscalizeInvoice,
  getInvoiceById,
  getInvoices,
  getInvoiceVersion,
  getInvoiceVersions,
  getShareableInvoice,
  getShareableInvoiceEslog,
  getShareableInvoiceHtml,
  getShareableInvoicePdf,
  renderDocumentHtml,
  renderDocumentPdf,
  renderInvoicePreview,
  updateInvoice,
  voidInvoice,
} from "../generated/invoices/invoices";

import type { RenderDocumentPdfParams } from "../generated/model";
import { downloadBlob } from "./download";
import type { SDKMethodOptions } from "./types";
import { wrapListMethod, wrapMethod } from "./utils";

const _renderPdf = wrapMethod(renderDocumentPdf);

export const invoices = {
  /** @see getShareableInvoice */
  getShareableInvoice: wrapMethod(getShareableInvoice),

  /** @see getShareableInvoiceHtml */
  getShareableInvoiceHtml: wrapMethod(getShareableInvoiceHtml),

  /** @see getShareableInvoicePdf */
  getShareableInvoicePdf: wrapMethod(getShareableInvoicePdf),

  /** @see getShareableInvoiceEslog */
  getShareableInvoiceEslog: wrapMethod(getShareableInvoiceEslog),

  /** @see createInvoice */
  create: wrapMethod(createInvoice),

  /** @see getInvoices */
  list: wrapListMethod(getInvoices),

  /** @see createCustomInvoice */
  createCustom: wrapMethod(createCustomInvoice),

  /** @see getInvoiceById */
  get: wrapMethod(getInvoiceById),

  /** @see updateInvoice */
  update: wrapMethod(updateInvoice),

  /** @see getInvoiceVersions */
  getVersions: wrapMethod(getInvoiceVersions),

  /** @see getInvoiceVersion */
  getVersion: wrapMethod(getInvoiceVersion),

  /** @see renderInvoicePreview */
  renderInvoicePreview: wrapMethod(renderInvoicePreview),

  /** @see voidInvoice */
  void: wrapMethod(voidInvoice),

  /** @see fiscalizeInvoice */
  fiscalizeInvoice: wrapMethod(fiscalizeInvoice),

  /** @see renderDocumentHtml */
  renderHtml: wrapMethod(renderDocumentHtml),

  /** @see renderDocumentPdf — returns a Blob */
  renderPdf: _renderPdf,

  /**
   * Download a document as PDF.
   * Convenience wrapper: calls renderPdf then triggers a browser download.
   */
  async downloadPdf(
    id: string,
    filename: string,
    params?: RenderDocumentPdfParams,
    options?: SDKMethodOptions,
  ): Promise<void> {
    const blob = await _renderPdf(id, params, options);
    downloadBlob(blob, filename);
  },
} as const;

export type InvoicesApi = typeof invoices;
